import { useEffect, useState } from 'react';
import axios from 'axios';
import { Image } from '../types/api/ImageType';

export enum RESULTS {
  pending = 'pending',
  ready = 'ready',
  fail = 'fail',
  ignored = 'ignored',
}

export type RetryProps = {
  image: any;
  url?: string;
  maxRetries?: number;
  msBetweenRetries?: number;
};

type UseRetryReturn = { result: RESULTS; image: Image };
export default function useRetry({ image, url, maxRetries = 3, msBetweenRetries = 3000 }: RetryProps): UseRetryReturn {
  const [retries, setRetry] = useState(maxRetries);
  const [result, setResult] = useState<RESULTS>(image?.imageState);
  const [resultImage, setResultImage] = useState<Image>(image);

  const reduceRetries = () => setRetry(p => p - 1);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (result === RESULTS.pending && retries !== 0 && url) {
      const abortController = new AbortController();
      timeout = setTimeout(async () => {
        await axios
          .get(url, { signal: abortController.signal })
          .then((res) => {
            const newImageResult = res.data?.image as Image | undefined;
            if (newImageResult?.imageState === RESULTS.ready) {
              setResultImage(newImageResult);
              setResult(RESULTS.ready);
            } else {
              reduceRetries();
            }
          })
          .catch(() => reduceRetries());
      }, msBetweenRetries);
      return () => {
        clearTimeout(timeout);
        abortController.abort();
      };
    }
    if (retries === 0) {
      setResult(RESULTS.fail);
    }
  }, [image, msBetweenRetries, result, resultImage, retries, url]);

  if (!url) {
    return { result: RESULTS.ignored, image: resultImage };
  }
  return { result, image: resultImage };
}
